import { base64UrlEncode, uuid } from '@luna/utils';
import { getEnv } from '@luna/env';
import { setCookie } from '@luna/cookies';
import { isCsrfFeatureEnabled } from '@shared/environment';

interface State {
    srcClientId: string;
    redirectUri: string;
    returnState: string;
    target?: string;
}

const CSRF_TOKEN_COOKIE = 'gt_csrf';

function createState(redirectUri: string, returnRouteWithoutHash: string, target?: string): State {
    let returnState = `handover/success/${returnRouteWithoutHash}`;

    if (isCsrfFeatureEnabled()) {
        const csrfToken = uuid();
        setCookie(CSRF_TOKEN_COOKIE, csrfToken);
        returnState = `${returnState}||${csrfToken}`;
    }

    if (!target) {
        return {
            srcClientId: getEnv().clientId,
            redirectUri,
            returnState,
        };
    }

    return {
        srcClientId: getEnv().clientId,
        redirectUri,
        returnState,
        target,
    };
}

export function getHandoverState(returnRouteWithoutHash: string, target?: string): string {
    let redirectUri = `${document.location.protocol}//${document.location.hostname}`;
    if (getEnv().environment === 'localDev') {
        redirectUri += `:8080?country=${getEnv().country}`;
    }

    const state = createState(redirectUri, returnRouteWithoutHash, target);

    return base64UrlEncode(JSON.stringify(state));
}
